<div fxLayout="column" fxHide.lt-md>
    <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
    <div *ngIf="isBrowserIE; else esignDetailsFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="esignDetailsFlexColumnTemplate"></ng-container>
    </div>
</div>

<div fxLayout="column" fxHide.gt-sm ngStyle.lt-md="padding-left: 8px; padding-right: 8px">
    <div fxFlex.lt-sm="10px" fxFlex.gt-sm="25px">&nbsp;</div>
    <ng-container *ngTemplateOutlet="eSignDetailsCardViewHeaderTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="eSignDetailsCardViewTemplate"></ng-container>
</div>

<ng-template #eSignDetailsCardViewHeaderTemplate>
    <div fxLayout="column" fxHide.gt-sm >
    <div fxFlex.lt-sm="10px" fxFlex.gt-sm="25px">&nbsp;</div>
        <div fxFlex="90%" *ngIf="!showSpinner">
            <div class="display-text normal-paragraph-spacing">
                <mat-card>
                    <mat-card-content>
                        <div class="display-text primary-dark-color-important" *ngIf="userFullName.length > 0">
                            <span style="white-space: nowrap !important;" fxLayoutAlign="start center">
                                <b>{{ userFullName }}</b>
                            </span>
                        </div>
                        <div class="display-text primary-dark-color-important">
                            <b><span
                                    i18n="@@esign-details.list.participant-id.label">esign-details.list.participant-id.label</span>:&nbsp;{{
                                participantIdString
                                }}</b>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #eSignDetailsCardViewTemplate>
    <div fxFlex="5%"></div>
    <div fxFlex="90%" *ngIf="!showSpinner">
        <div class="display-text normal-paragraph-spacing">
            <mat-card>
                <mat-card-content>
                    <div fxLayout="column">
                        <div fxLayout="column" fxLayoutGap="16px">
                            <div fxLayout="column">
                                <div *ngIf="isBrowserIE; else eSignDetailsCardViewPageHeaderFlexColumnTemplate"
                                    [ngClass]="{ 'ie-display': isBrowserIE }">
                                    <ng-container
                                        *ngTemplateOutlet="eSignDetailsCardViewPageHeaderFlexColumnTemplate"></ng-container>
                                </div>
                            </div>
                            <!-- Filter Control -->
                            <mat-form-field *ngIf="esignNoteInfoList.length > 5" appearance="fill" style="width: 100%;">
                                <mat-label>Filter by Note Status</mat-label>
                                <mat-select [(ngModel)]="selectedNoteStatus" (selectionChange)="filterNotes()">
                                    <mat-option *ngFor="let status of uniqueNoteStatuses" [value]="status">
                                        {{ status }}
                                    </mat-option>
                                    <mat-option [value]="''">All</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <ng-container *ngFor="let row of filteredNotesList">
                                <mat-card *ngIf="row.noteId">
                                    <mat-card-header>
                                        <div style="width: 100%;">
                                            <!-- Left Section: Note ID and Note Status -->
                                            <div>
                                                <mat-card-title>{{ row.noteId }}
                                                </mat-card-title>
                                                <mat-card-subtitle>{{ row.noteStatus }}
                                                </mat-card-subtitle>
                                                <div *ngIf="row.noteDate"
                                                    style="display: flex; justify-content: space-between;">
                                                    <mat-label><span class="header-superscript header-after-content-2"
                                                            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                                            i18n="@@loan-details.list.table.column-header.note-date">loan-details.list.table.column-header.note-date</span></mat-label>
                                                    <span style="text-align: right;">{{ row.noteDate | date: 'MM/dd/yyyy'}}</span>
                                                </div>
                                                <div *ngIf="row.originalNoteAmount"
                                                    style="display: flex; justify-content: space-between;">
                                                    <mat-label>
                                                        <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                                            i18n="@@esign-details.list.table.column-header.original-note-amount">esign-details.list.table.column-header.original-note-amount</span>
                                                    </mat-label>
                                                    <span style="text-align: right;">{{ row.originalNoteAmount | currency }}</span>
                                                </div>
                                                <div *ngIf="row.schoolName"
                                                    style="display: flex; justify-content: space-between;">
                                                    <mat-label>
                                                        <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                                                            i18n="@@esign-details.list.table.column-header.school-name">esign-details.list.table.column-header.school-name</span>
                                                    </mat-label>
                                                    <span style="text-align: right;">{{ row.schoolName }}</span>
                                                </div>
                                            </div>
                                            <!-- <button mat-button color="primary"
                                                (click)="selectCardNote(row.noteId, row.relationshipType)">View
                                                Details</button> -->
                                        </div>

                                    </mat-card-header>

                                    <mat-card-actions
                                        style="display: flex; justify-content: right; align-items: right;">
                                        <button mat-flat-button color="primary" (click)="selectCardNote(row.noteId, row.relationshipType)"
                                            i18n-matTooltip="@@esign-details.table.column-header.options"
                                            matTooltip="esign-details.table.column-header.options"
                                            i18n="@@esign-details.table.column-header.options">
                                            esign-details.table.column-header.options
                                        </button>
                                    </mat-card-actions>

                                    <!-- Dynamically Render Note Details -->
                                    <mat-card-content *ngIf="selectedNoteId === row.noteId">

                                        <div fxLayout="column" class="primary-lightest-bg note-details"
                                            *ngIf="selectedNoteId !== null && selectedNoteId > 0">

                                            <ng-container *ngTemplateOutlet="esignDetailsNoteDetailFlexColumnTemplate"></ng-container>

                                            <!-- <div *ngIf="isBrowserIE; else eSignDetailsNoteDetailFlexColumnTemplate"
                                                [ngClass]="{ 'ie-display': isBrowserIE }">
                                                <ng-container *ngTemplateOutlet="eSignDetailsNoteDetailFlexColumnTemplate"></ng-container>
                                            </div> -->




                                        </div>
                                    </mat-card-content>

                                </mat-card>
                            </ng-container>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #eSignDetailsCardViewPageHeaderFlexColumnTemplate>
    <div fxFlex="5%"></div>
    <div fxLayout="column" fxFlex="90%">
        <div class="display-text primary-dark-color-important" *ngIf="userFullName.length > 0">
            <span style="white-space: nowrap !important;" fxLayoutAlign="start center">
                <b><span i18n="@@page-header.loan-details.e-sign">page-header.loan-details.e-sign</span></b>
            </span>
        </div>
        <div fxFlex="100%" class="border-bottom-blue" style="margin-top: 16px"></div>
    </div>
</ng-template>

<ng-template #esignDetailsFlexColumnTemplate>
    <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
    <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
        <div *ngIf="isBrowserIE && media.isActive('lt-md'); else esignDetailsMainFlexColumnTemplate">
            <ng-container *ngTemplateOutlet="esignDetailsMainFlexColumnTemplate"></ng-container>
        </div>
    </div>
    <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
</ng-template>

<ng-template #esignDetailsMainFlexColumnTemplate>
    <div fxFlex="5%" fxHide.lt-md></div>
    <div fxFlex="90%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px" *ngIf="showSpinner">
        <div class="display-text normal-paragraph-spacing" style="text-align: center">
            <mat-spinner color="accent" diameter="64"></mat-spinner>
        </div>
    </div>
    <div fxFlex="90%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px" *ngIf="!showSpinner">
        <div class="display-text normal-paragraph-spacing">
            <mat-card>
                <mat-card-content>
                    <div fxLayout="column" *ngIf="!esignNoteInfoFound">
                        <div *ngIf="isBrowserIE; else esignDetailsNoRecordsFlexColumnTemplate"
                            [ngClass]="{ 'ie-display': isBrowserIE }">
                            <ng-container *ngTemplateOutlet="esignDetailsNoRecordsFlexColumnTemplate"></ng-container>
                        </div>
                    </div>
                    <div fxLayout="column" *ngIf="esignNoteInfoFound">
                        <div *ngIf="isBrowserIE; else esignDetailsListFlexColumnTemplate"
                            [ngClass]="{ 'ie-display': isBrowserIE }">
                            <ng-container *ngTemplateOutlet="esignDetailsListFlexColumnTemplate"></ng-container>
                        </div>
                    </div>
                    <div fxLayout="column" class="primary-lightest-bg "
                        *ngIf="selectedNoteId !== null && selectedNoteId > 0" id="noteDetails">
                        <div *ngIf="isBrowserIE; else esignDetailsNoteDetailFlexColumnTemplate"
                            [ngClass]="{ 'ie-display': isBrowserIE }">
                            <ng-container *ngTemplateOutlet="esignDetailsNoteDetailFlexColumnTemplate"></ng-container>
                        </div>
                    </div>
                    <div fxLayout="column">
                        <div *ngIf="isBrowserIE; else esignDetailsScrollToTopFlexColumnTemplate"
                            [ngClass]="{ 'ie-display': isBrowserIE }">
                            <ng-container *ngTemplateOutlet="esignDetailsScrollToTopFlexColumnTemplate"></ng-container>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #esignDetailsNoRecordsFlexColumnTemplate>
    <div fxLayout="column">
        <div class="display-text primary-color-important normal-paragraph-spacing">
            <b><span i18n="@@esign-details.list.title">esign-details.list.title</span></b>
        </div>
        <div class="display-text primary-dark-color-important" *ngIf="userFullName.length > 0">
            <span style="white-space: nowrap !important;" fxLayoutAlign="start center">
                <b>{{ userFullName }}</b>
            </span>
        </div>
        <div class="display-text primary-dark-color-important">
            <b><span
                    i18n="@@esign-details.list.participant-id.label">esign-details.list.participant-id.label</span>:&nbsp;{{
                participantIdString
                }}</b>
        </div>
        <div class="display-text">
            <i><span i18n="@@esign-details.list.no-records-text">esign-details.list.no-records-text</span></i>
        </div>
    </div>
</ng-template>

<ng-template #esignDetailsListFlexColumnTemplate>
    <div fxLayout="column">
        <div class="display-text primary-color-important normal-paragraph-spacing">
            <b><span i18n="@@esign-details.list.title">esign-details.list.title</span></b>
        </div>
        <div class="display-text primary-dark-color-important" *ngIf="userFullName.length > 0">
            <span style="white-space: nowrap !important;" fxLayoutAlign="start center">
                <b>{{ userFullName }}</b>
            </span>
        </div>
        <div class="display-text primary-dark-color-important">
            <b><span
                    i18n="@@esign-details.list.participant-id.label">esign-details.list.participant-id.label</span>:&nbsp;{{
                participantIdString
                }}</b>
        </div>
        <div class="display-text">
            <i><span i18n="@@esign-details.list.top-helper-text">esign-details.list.top-helper-text</span></i>
        </div>
        <div *ngIf="isBrowserIE; else esignDetailsListTableFlexColumnTemplate"
            [ngClass]="{ 'ie-display': isBrowserIE }">
            <ng-container *ngTemplateOutlet="esignDetailsListTableFlexColumnTemplate"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #esignDetailsScrollToTopFlexColumnTemplate>
    <div fxLayout="column" *ngIf="esignNoteInfoFound">
        <div fxLayoutAlign="center center" style="margin-top: 24px;">
            <button mat-stroked-button color="primary" (click)="scrollToTop()" i18n="@@esign-details.list.go-to-top">
                esign-details.list.go-to-top
            </button>
        </div>
    </div>
</ng-template>

<ng-template #esignDetailsListTableFlexColumnTemplate>
    <div fxFlex="100%" class="border-bottom-blue" style="margin-top: 16px"></div>
    <div fxFlex="100%" [ngStyle]="{ display: tableDisplayStyle }" style="margin-top: 12px">
        <mat-table #table [dataSource]="tableDataSource" ngClass.lt-md="small-table-text">
            <!-- noteId Column -->
            <ng-container matColumnDef="noteId">
                <mat-header-cell *matHeaderCellDef fxFlex="15%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@esign-details.list.table.column-header.note-id">esign-details.list.table.column-header.note-id</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="15%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">
                    <button mat-button color="primary" (click)="selectNote(row.noteId, row.relationshipType)">
                        <b>{{ row.noteId }}</b>
                    </button>
                </mat-cell>
            </ng-container>
            <!-- noteDate Column -->
            <ng-container matColumnDef="noteDate">
                <mat-header-cell *matHeaderCellDef fxFlex="15%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@esign-details.list.table.column-header.note-date">esign-details.list.table.column-header.note-date</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="15%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">
                    {{ row.noteDate | date: 'MM/dd/yyyy' }}
                </mat-cell>
            </ng-container>
            <!-- originalNoteAmount Column -->
            <ng-container matColumnDef="originalNoteAmount">
                <mat-header-cell *matHeaderCellDef fxFlex="15%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@esign-details.list.table.column-header.original-note-amount">esign-details.list.table.column-header.original-note-amount</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="15%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">
                    {{ row.originalNoteAmount | currency }}
                </mat-cell>
            </ng-container>
            <!-- schoolName Column -->
            <ng-container matColumnDef="schoolName">
                <mat-header-cell *matHeaderCellDef fxFlex="25%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@esign-details.list.table.column-header.school-name">esign-details.list.table.column-header.school-name</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="25%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">
                    {{ row.schoolName }}
                </mat-cell>
            </ng-container>
            <!-- noteStatus Column -->
            <ng-container matColumnDef="noteStatus">
                <mat-header-cell *matHeaderCellDef fxFlex="20%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@esign-details.list.table.column-header.note-status">esign-details.list.table.column-header.note-status</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="20%" ngClass.lt-md="small-table-text"
                    [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">
                    {{ row.noteStatus }}
                </mat-cell>
            </ng-container>
            <!-- options Column -->
            <ng-container matColumnDef="options">
                <mat-header-cell *matHeaderCellDef fxFlex="10%">
                    <span [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
                        i18n="@@esign-details.table.column-header.options">esign-details.table.column-header.options</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" fxFlex="10%" class="mat-column-data-centered"
                    ngClass.lt-md="small-table-text">
                    <span [ngClass]="{ 'mat-column-options-ie': isBrowserIE }">
                        <button mat-flat-button color="primary" fxHide.lt-md
                            (click)="selectNote(row.noteId, row.relationshipType)"
                            i18n-matTooltip="@@esign-details.table.column.options.button.tool-tip"
                            matTooltip="esign-details.table.column.options.button.tool-tip"
                            i18n="@@esign-details.table.column.options.button.label">
                            esign-details.table.column.options.button.label
                        </button>
                        <a class="button-link" fxHide.gt-sm (click)="selectNote(row.noteId, row.relationshipType)"
                            i18n-matTooltip="@@esign-details.table.column.options.anchor.tool-tip"
                            matTooltip="esign-details.table.column.options.anchor.tool-tip"
                            i18n="@@esign-details.table.column.options.anchor.label">esign-details.table.column.options.anchor.label</a>
                    </span>
                </mat-cell>
            </ng-container>
            <mat-header-row class="primary-light-bg-top-to-bottom-gradient" *matHeaderRowDef="tableDisplayedColumns"
                ngClass.lt-md="small-header-row"></mat-header-row>
            <mat-row *matRowDef="let row; columns: tableDisplayedColumns" ngClass.lt-md="small-row"
                [ngClass]="{ 'primary-lightest-bg': row.noteId === selectedNoteId }"></mat-row>
        </mat-table>
    </div>
    <div fxFlex="100%" fxLayoutAlign="end center" class="small-display-text primary-light-color"
        *ngIf="esignNoteInfoFound">
        <app-table-record-count [recordCount]="this.esignNoteInfoList.length"
            i18n-singularLabel="@@esign-details.list.table.record-count.singular-label"
            singularLabel="esign-details.list.table.record-count.singular-label"
            i18n-multipleLabel="@@esign-details.list.table.record-count.multiple-label"
            multipleLabel="esign-details.list.table.record-count.multiple-label"></app-table-record-count>
    </div>
    <div fxFlex="100%" style="margin-top: 16px"></div>
</ng-template>

<ng-template #esignDetailsNoteDetailFlexColumnTemplate>
    <div fxFlex="100%" style="margin-top: 24px;"></div>
    <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
        <div *ngIf="isBrowserIE && media.isActive('lt-md'); else esignDetailsNoteDetailTwoColumnsFlexColumnTemplate">
            <ng-container *ngTemplateOutlet="esignDetailsNoteDetailTwoColumnsFlexColumnTemplate"></ng-container>
        </div>
    </div>
    <div fxFlex="100%" fxLayoutAlign="center center" style="margin-top: 24px;">
        <button mat-flat-button color="primary" (click)="openEsign()" i18n="@@esign-details.detail.open-esign">
            esign-details.detail.open-esign
        </button>
    </div>
    <div fxFlex="100%" style="margin-top: 24px;"></div>
</ng-template>

<ng-template #esignDetailsNoteDetailTwoColumnsFlexColumnTemplate>
    <div fxFlex="5%" fxHide.lt-md></div>
    <div fxFlex.lt-md="100%" fxFlex.gt-sm="45%">
        <app-note-detail [noteDetailType]="noteDetailTypes.Esign" [noteId]="this.selectedNoteId"></app-note-detail>
    </div>
    <div fxFlex.lt-md="100%" fxFlex.gt-sm="45%">
        <div fxLayout="column">
            <div *ngIf="isBrowserIE; else esignDetailsNoteDetailRightColumnFlexColumnTemplate"
                [ngClass]="{ 'ie-display': isBrowserIE }">
                <ng-container *ngTemplateOutlet="esignDetailsNoteDetailRightColumnFlexColumnTemplate"></ng-container>
            </div>
        </div>
    </div>
    <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #esignDetailsNoteDetailRightColumnFlexColumnTemplate>
    <app-note-repay-schedule-list [noteId]="this.selectedNoteId"></app-note-repay-schedule-list>
    <app-note-disbursement-schedule-list [noteId]="this.selectedNoteId"
        style="margin-top: 36px;"></app-note-disbursement-schedule-list>
</ng-template>